/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
  });
  
  if (document.getElementById('slider')) {

    var glide = new Glide('#slider', {
      autoplay: 7000,
      animationDuration: 2000,
      hoverpause: true,
      type: 'carousel',
      perView: 4,
      focusAt: 'center',
      breakpoints: {
        1200: {
          perView: 4
        },
        800: {
          perView: 3
        },
        480: {
          perView: 1
        }
      }
    })

    glide.mount();
    
  }

  $(window).bind('scroll',function(e){
    parallaxScroll();
  });

  function parallaxScroll(){
    var scrolled = $(window).scrollTop();
    $('.home').css('background-position-y', ((70 + scrolled * .30)) + 'px');
    $('.home .proton-parallax, .page-template-about .proton-parallax').css('background-position-y', ((180 + scrolled * -.15)) + 'px');
    $('.page-template-about .proton-parallax').css('background-position-y', ((100 + scrolled * -.15)) + 'px');
    $('.page-template-events .proton-parallax').css('background-position-y', ((400 + scrolled * -.15)) + 'px');
    $('.page-template-contact .proton-parallax').css('background-position-y', ((130 + scrolled * -.15)) + 'px');
  }

  var icon = document.querySelector('#top-bar-menu .mobile-menu-icon');
  icon.addEventListener("click", function () {
    icon.classList.toggle('clicked');
    $('#mobile-menu').toggleClass('active');
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 145) {
      $('#back-to-top').addClass('active');
    } else {
      $('#back-to-top').removeClass('active');
    }
  });

  $(window).scroll(function() {
    if ($(document).scrollTop() > 155) {
      $('#short-header').css({ top: '0px' });
    } else {
      $('#short-header').css({ top: '-170px' });
    }
  });
  
  $('#back-to-top').click(function() {
    $('html, body').animate({scrollTop: 0}, 1200);
  });

});
